import { useState } from 'react'
import { message } from 'antd'
import { trainingQuery } from 'parts/requests/training/trainingQuery'
import { TrainingListController } from 'widgets/trainingsListAdmin/TrainingListController'
import TrainingEntityTypes from 'parts/types/TrainingEntityTypes'

/**
 * Хук для публикации курса (isPublished = true)
 * @param rawTraining — объект курса
 */
export const usePublishTraining = (
	rawTraining: TrainingEntityTypes.TrainingAdmin
) => {
	const [loading, setLoading] = useState(false)
	const updateDataInTrainingsList = TrainingListController.useGetUpdate()

	const { mutate } = trainingQuery.updateTraining.useMutation({
		onMutate: () => setLoading(true),
		onError: () => {
			setLoading(false)
			message.error('Ошибка при публикации курса')
		},
		onSuccess: () => {
			setLoading(false)
			message.success('Курс опубликован')
			updateDataInTrainingsList()
		},
		onSettled: () => setLoading(false),
	})

	const handlePublish = (event?: React.SyntheticEvent) => {
		if (event) event.preventDefault()
		mutate({
			id: rawTraining.id,
			name: rawTraining.name,
			description: rawTraining.description,
			cover: rawTraining.cover,
			level: rawTraining.level,
			lang: rawTraining.lang,
			type: rawTraining.type,
			order: rawTraining.order,
			showOnMainScreen: rawTraining.showOnMainScreen,
			isPublished: true,
		})
	}

	return { handlePublish, loading }
}
